import { RegisterType, SubCategory } from 'types';

import { Item } from './components/Item';

type EditListProps = {
  subCategories: SubCategory[];
  register?: RegisterType;
  fieldArrayName?: string;
  onRemove?: (index: number) => void;
};

export function EditList(props: EditListProps): React.ReactElement {
  const { subCategories, register, fieldArrayName = 'subCategories', onRemove } = { ...props };

  const subCategoriesMapped = subCategories?.map((item: SubCategory, index: number) => (
    <Item
      key={item.id}
      register={register}
      nameEn={`${fieldArrayName}.${index}.nameEn`}
      nameIt={`${fieldArrayName}.${index}.nameIt`}
      valueEn={item.name_en}
      valueIt={item.name_it}
      onRemove={onRemove ? () => onRemove(index) : undefined}
    />
  ));

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{subCategoriesMapped}</>;
}
